/**
 * Tiny cross-cutting signal: is any useLlmChat instance currently mid-stream?
 *
 * BuildVersionChecker force-reloads the page on a deploy-version mismatch (on mount,
 * every 5 minutes, and whenever the tab regains focus) with no visibility into what the
 * user is doing elsewhere in the app. A reload firing mid-send aborts the in-flight
 * /llm/chat/completions request before the server ever sees it -- the conversation gets
 * created, but the message and AI response never do, with no error shown (confirmed live,
 * 2026-08-07: a deploy landing while a user was mid-send silently ate their message this
 * exact way). A module-level counter (not a boolean) because more than one ChatHub/useLlmChat
 * instance can theoretically be mounted at once; the reload should wait for all of them.
 */

let activeStreamCount = 0;

export function markLlmStreamActive(): void {
  activeStreamCount += 1;
}

export function markLlmStreamInactive(): void {
  activeStreamCount = Math.max(0, activeStreamCount - 1);
}

export function hasActiveLlmStream(): boolean {
  return activeStreamCount > 0;
}
